import { render, staticRenderFns } from "./CustomLayout.vue?vue&type=template&id=5ed7f075&scoped=true&"
import script from "./CustomLayout.script.js?vue&type=script&lang=js&"
export * from "./CustomLayout.script.js?vue&type=script&lang=js&"
import style0 from "./CustomLayout.scss?vue&type=style&index=0&id=5ed7f075&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed7f075",
  null
  
)

export default component.exports